module.exports = __webpack_public_path__ + "static/media/pintung.0194adec.svg";